export enum PALETTE {
	green = '#aae053',
	green2 = '#9cd541',
	green3 = '#faffa3',
	darkGreen = '#67941f',
	blue = '#4a82ff',
	blue2 = '#3873f7',
	blue3 = '#2c65e6',
	blue4 = '#3d68fc',
	red = '#ff486b',
	red2 = '#f3365a',
	red3 = '#d3063a',
	orange = '#ffb23f',
	orange2 = '#c57c00',
	pink1 = '#d1426f',
	pink2 = '#dd547f',
	dark = '#2d272d',
	epicModeDark = '#2d272d',
	purple = '#534468',
	lightBlue = '#b6e7ff',
	peach = '#ffd5b3',
	lightGrey = '#f9f6ef',
	lightGrey2 = '#e6e0d0',
	lightGrey3 = '#f2eee5',
	purple2 = '#745a9e',
	purple3 = '#614988',
	purple4 = '#9983bb',
	purple5 = '#402e59',
	purple6 = '#221f25',
	yellow = '#ffce3c',
	lightPurple = '#745a9e',
	brightPurple = '#bdb2ef',
	darkPurple = '#3a2c4d'
}
